<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">직원관리</span>
            <span class="txt">현재 근무중인 직원을 확인할 수 있으며, 직원 설정이 가능합니다.</span>
        </div>

        <div class="employee-top-info">
            <ul class="select-photo-list">
                <li>
                    <a href="#">
                        <img
                            :src="employeeInfo.imageUrl === null ? '/img/temp/no_photo.jpg' : employeeInfo.imageUrl"
                            alt=""
                            @error="imageUrlAlt"
                        />
                        <span class="name">{{ staffTopInfo.name }}</span>
                        <span class="tel">{{ staffTopInfo.phone | phoneNumberFilter }}</span>
                        <span class="type">{{ staffTopInfo.roleName }}</span>
                        <span class="detail">{{ staffTopInfo.staffTeams }}</span>
                    </a>
                </li>
            </ul>
        </div>

        <div class="com-btn-area">
            <div class="right-box">
                <a class="com-btn blue" href="#" @click="onPriceHistory">급여변동내역보기</a>
            </div>
        </div>

        <p class="com-sub-title">
            기본설정
            <small>기본급과 인센티브를 설정하며 '월' 단위로 급여변경이 가능합니다.</small>
        </p>

        <div class="com-card-input half-type">
            <div class="left-box">
                <div class="line">
                    <span class="tit">
                        기본급
                        <small>(지급하지 않는 경우 미입력)</small>
                    </span>
                    <div class="input-cnt">
                        <input :value="basePay" class="w220" disabled type="text" />
                        <span class="txt">원</span>
                    </div>
                </div>
            </div>
            <div class="right-box">
                <div class="line">
                    <span class="tit">
                        인센티브
                        <small>(지급하지 않는 경우 미입력)</small>
                    </span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-check">
                                <input id="check-1-1" :checked="!incentiveYn" disabled name="check-1" type="checkbox" />
                                <label for="check-1-1">없음</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-check w100">
                                <input id="check-1-2" :checked="incentiveYn" disabled name="check-1" type="checkbox" />
                                <label for="check-1-2">신규 매출</label>
                            </div>
                            <input v-model="pay.incentiveNewSale" class="w60 center" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-check w100">
                                <input id="check-1-3" :checked="incentiveYn" disabled name="check-1" type="checkbox" />
                                <label for="check-1-3">재등록 매출</label>
                            </div>
                            <input v-model="pay.incentiveRenewSale" class="w60 center" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-check w100">
                                <input id="check-1-4" :checked="incentiveYn" disabled name="check-1" type="checkbox" />
                                <label for="check-1-4">총 매출</label>
                            </div>
                            <input v-model="pay.incentiveTotalSale" class="w60 center" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        부가세 정책
                        <!--
                        관련 디자인이 없는 관계로 주석처리함.
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-1-1" :checked="incentiveVat" disabled name="radio-1" type="radio" />
                                <label for="radio-1-1">부가세를 제외하지 않습니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-1-2" :checked="!incentiveVat" disabled name="radio-1" type="radio" />
                                <label for="radio-1-2">결제금액에서 10%를 제외하고 인센티브를 계산합니다.</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <p class="com-sub-title">
            이용권 별 설정
            <small>이용권 종류별로 급여를 설정하며 '일' 단위로 급여변경이 가능합니다.</small>
        </p>

        <div class="com-card-input half-type full">
            <span class="top-title">
                이용권 별 급여 설정
                <small>(지급하지 않는 경우 미입력)</small>
            </span>
            <div class="left-box full">
                <!-- 개인 급여 설정 -->
                <div class="line">
                    <span class="tit">
                        <span class="txt-blue">개인 급여 설정</span>
                        <!--
                        제플린에 관련 디자인이 없기 때문에 주석처리함.
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-s1-1"
                                v-model="useRadio.private"
                                :checked="useRadio.private"
                                disabled
                                name="radio-s1"
                                type="radio"
                                value="FA"
                            />
                            <label for="radio-s1-1">고정금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-s1-2"
                                v-model="useRadio.private"
                                :checked="useRadio.private"
                                disabled
                                name="radio-s1"
                                type="radio"
                                value="FP"
                            />
                            <label for="radio-s1-2">고정퍼센트</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-s1-3"
                                v-model="useRadio.private"
                                :checked="useRadio.private"
                                disabled
                                name="radio-s1"
                                type="radio"
                                value="CA"
                            />
                            <label for="radio-s1-3">횟수 별 금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-s1-4"
                                v-model="useRadio.private"
                                :checked="useRadio.private"
                                disabled
                                name="radio-s1"
                                type="radio"
                                value="CP"
                            />
                            <label for="radio-s1-4">횟수 별 퍼센트</label>
                        </div>
                    </div>
                    <div class="input-cnt box-type">
                        <!-- 고정 금액 -->
                        <div v-show="useRadio.private == 'FA'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">원</span>
                        </div>
                        <!-- 고정퍼센트 -->
                        <div v-show="useRadio.private == 'FP'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                        <!-- 횟수 별 금액 -->
                        <div v-show="useRadio.private == 'CA'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                        </div>
                        <!-- 횟수 별 퍼센트 -->
                        <div v-show="useRadio.private == 'CP'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="useRadio.private == 'CP' || useRadio.private == 'FP'" class="line">
                    <span class="tit">
                        부가세 정책
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                    </span>
                    <div class="input-cnt">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s2-1" checked disabled name="radio-s2" type="radio" />
                                <label for="radio-s2-1">부가세를 제외하지 않습니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s2-2" disabled name="radio-s2" type="radio" />
                                <label for="radio-s2-2">1회당 단가에서 부가세 10%를 제외하고 정산합니다.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">NO-SHOW(결석) 정책</span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s3-1"
                                    v-model="usePayRadio.private"
                                    disabled
                                    name="radio-s3"
                                    type="radio"
                                    value="CME"
                                />
                                <label for="radio-s3-1">횟수차감과 동시에 동일한 금액으로 정산합니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s3-2"
                                    v-model="usePayRadio.private"
                                    disabled
                                    name="radio-s3"
                                    type="radio"
                                    value="CMF"
                                />
                                <label for="radio-s3-2">횟수차감과 동시에</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">원으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s3-3"
                                    v-model="usePayRadio.private"
                                    disabled
                                    name="radio-s3"
                                    type="radio"
                                    value="CMP"
                                />
                                <label for="radio-s3-3">횟수차감과 동시에 기존급여의</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">% 으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s3-4"
                                    v-model="usePayRadio.private"
                                    disabled
                                    name="radio-s3"
                                    type="radio"
                                    value="CXX"
                                />
                                <label for="radio-s3-4">횟수차감만 하고 정산하지 않습니다. (정산금액 0원)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- //개인 급여 설정 -->

                <!-- 듀엣 급여 설정 -->
                <div class="line">
                    <span class="tit">
                        <span class="txt-blue">듀엣 급여 설정</span>
                        <!--
                        제플린에 관련 디자인이 없는 관계로 주석처리함
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-d1-1"
                                v-model="useRadio.duet"
                                :checked="useRadio.duet"
                                disabled
                                name="radio-d1"
                                type="radio"
                                value="FA"
                            />
                            <label for="radio-d1-1">고정금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-d1-2"
                                v-model="useRadio.duet"
                                :checked="useRadio.duet"
                                disabled
                                name="radio-d1"
                                type="radio"
                                value="FP"
                            />
                            <label for="radio-d1-2">고정퍼센트</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-d1-3"
                                v-model="useRadio.duet"
                                :checked="useRadio.duet"
                                disabled
                                name="radio-d1"
                                type="radio"
                                value="CA"
                            />
                            <label for="radio-d1-3">횟수 별 금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-d1-4"
                                v-model="useRadio.duet"
                                :checked="useRadio.duet"
                                disabled
                                name="radio-d1"
                                type="radio"
                                value="CP"
                            />
                            <label for="radio-d1-4">횟수 별 퍼센트</label>
                        </div>
                    </div>
                    <div class="input-cnt box-type">
                        <!-- 고정 금액 -->
                        <div v-show="useRadio.duet == 'FA'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">원</span>
                        </div>
                        <!-- 고정퍼센트 -->
                        <div v-show="useRadio.duet == 'FP'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                        <!-- 횟수 별 금액 -->
                        <div v-show="useRadio.duet == 'CA'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                        </div>
                        <!-- 횟수 별 퍼센트 -->
                        <div v-show="useRadio.duet == 'CP'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="useRadio.duet == 'CP' || useRadio.duet == 'FP'" class="line">
                    <span class="tit">
                        부가세 정책
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                    </span>
                    <div class="input-cnt">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s4-1" checked disabled name="radio-s4" type="radio" />
                                <label for="radio-s4-1">부가세를 제외하지 않습니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s4-2" disabled name="radio-s4" type="radio" />
                                <label for="radio-s4-2">1회당 단가에서 부가세 10%를 제외하고 정산합니다.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">NO-SHOW(결석) 정책</span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s5-1"
                                    v-model="usePayRadio.duet"
                                    disabled
                                    name="radio-s5"
                                    type="radio"
                                    value="CME"
                                />
                                <label for="radio-s5-1">횟수차감과 동시에 동일한 금액으로 정산합니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s5-2"
                                    v-model="usePayRadio.duet"
                                    disabled
                                    name="radio-s5"
                                    type="radio"
                                    value="CMF"
                                />
                                <label for="radio-s5-2">횟수차감과 동시에</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">원으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s5-3"
                                    v-model="usePayRadio.duet"
                                    disabled
                                    name="radio-s5"
                                    type="radio"
                                    value="CMP"
                                />
                                <label for="radio-s5-3">횟수차감과 동시에 기존급여의</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">% 으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s5-4"
                                    v-model="usePayRadio.duet"
                                    disabled
                                    name="radio-s5"
                                    type="radio"
                                    value="CXX"
                                />
                                <label for="radio-s5-4">횟수차감만 하고 정산하지 않습니다. (정산금액 0원)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- //듀엣 급여 설정 -->

                <!-- 오티 급여 설정 -->
                <div class="line">
                    <span class="tit">
                        <span class="txt-blue">OT 급여 설정</span>
                        <!--
                        제플린에 해당 디자인이 없기 때문에 주석처리함.
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-ot1-1"
                                v-model="useRadio.ot"
                                :checked="useRadio.ot"
                                disabled
                                name="radio-ot1"
                                type="radio"
                                value="FA"
                            />
                            <label for="radio-ot1-1">고정금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-ot1-2"
                                v-model="useRadio.ot"
                                :checked="useRadio.ot"
                                disabled
                                name="radio-ot1"
                                type="radio"
                                value="FP"
                            />
                            <label for="radio-ot1-2">고정퍼센트</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-ot1-3"
                                v-model="useRadio.ot"
                                :checked="useRadio.ot"
                                disabled
                                name="radio-ot1"
                                type="radio"
                                value="CA"
                            />
                            <label for="radio-ot1-3">횟수 별 금액</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-ot1-4"
                                v-model="useRadio.ot"
                                :checked="useRadio.ot"
                                disabled
                                name="radio-ot1"
                                type="radio"
                                value="CP"
                            />
                            <label for="radio-ot1-4">횟수 별 퍼센트</label>
                        </div>
                    </div>
                    <div class="input-cnt box-type">
                        <!-- 고정 금액 -->
                        <div v-show="useRadio.ot == 'FA'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">원</span>
                        </div>
                        <!-- 고정퍼센트 -->
                        <div v-show="useRadio.ot == 'FP'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                        <!-- 횟수 별 금액 -->
                        <div v-show="useRadio.ot == 'CA'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">%</span>
                                </div>
                            </div>
                        </div>
                        <!-- 횟수 별 퍼센트 -->
                        <div v-show="useRadio.ot == 'CP'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-show="useRadio.ot == 'CP' || useRadio.ot == 'FP'" class="line">
                    <span class="tit">
                        부가세 정책
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                    </span>
                    <div class="input-cnt">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s6-1" checked disabled name="radio-s6" type="radio" />
                                <label for="radio-s6-1">부가세를 제외하지 않습니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s6-2" disabled name="radio-s6" type="radio" />
                                <label for="radio-s6-2">1회당 단가에서 부가세 10%를 제외하고 정산합니다.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">NO-SHOW(결석) 정책</span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s7-1"
                                    v-model="usePayRadio.ot"
                                    disabled
                                    name="radio-s7"
                                    type="radio"
                                    value="CME"
                                />
                                <label for="radio-s7-1">횟수차감과 동시에 동일한 금액으로 정산합니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s7-2"
                                    v-model="usePayRadio.ot"
                                    disabled
                                    name="radio-s7"
                                    type="radio"
                                    value="CMF"
                                />
                                <label for="radio-s7-2">횟수차감과 동시에</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">원으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s7-3"
                                    v-model="usePayRadio.ot"
                                    disabled
                                    name="radio-s7"
                                    type="radio"
                                    value="CMP"
                                />
                                <label for="radio-s7-3">횟수차감과 동시에 기존급여의</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">% 으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s7-4"
                                    v-model="usePayRadio.ot"
                                    disabled
                                    name="radio-s7"
                                    type="radio"
                                    value="CXX"
                                />
                                <label for="radio-s7-4">횟수차감만 하고 정산하지 않습니다. (정산금액 0원)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- //오티 급여 설정 -->

                <!-- 그룹/쿠폰 급여 설정 -->
                <div class="line">
                    <span class="tit">
                        <span class="txt-blue">그룹/쿠폰 급여 설정</span>
                        <!--
                        제플린에 해당 디자인이 없는 관계로 주석처리함.
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <div class="input-cnt">
                        <div class="com-radio">
                            <input
                                id="radio-g1-1"
                                v-model="useRadio.group"
                                :checked="useRadio.group"
                                disabled
                                name="radio-g1"
                                type="radio"
                                value="TM"
                            />
                            <label for="radio-g1-1">타임별</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-g1-2"
                                v-model="useRadio.group"
                                :checked="useRadio.group"
                                disabled
                                name="radio-g1"
                                type="radio"
                                value="MO"
                            />
                            <label for="radio-g1-2">인당</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-g1-3"
                                v-model="useRadio.group"
                                :checked="useRadio.group"
                                disabled
                                name="radio-g1"
                                type="radio"
                                value="MT"
                            />
                            <label for="radio-g1-3">인원별</label>
                        </div>
                        <div class="com-radio">
                            <input
                                id="radio-g1-4"
                                v-model="useRadio.group"
                                :checked="useRadio.group"
                                disabled
                                name="radio-g1"
                                type="radio"
                                value="FP"
                            />
                            <label for="radio-g1-4">고정 퍼센트</label>
                        </div>
                    </div>
                    <div class="input-cnt box-type">
                        <!-- 고정 금액 -->
                        <div v-show="useRadio.group == 'TM'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">원</span>
                        </div>
                        <!-- 고정퍼센트 -->
                        <div v-show="useRadio.group == 'MO'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">원</span>
                        </div>
                        <!-- 횟수 별 금액 -->
                        <div v-show="useRadio.group == 'MT'" class="section">
                            <div class="sub-btn-wrap">
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">회 이하</span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                                <div class="sub-line">
                                    <input class="w60 center" disabled type="text" />
                                    <span class="txt">
                                        회
                                        <span class="red">초과</span>
                                    </span>
                                    <input class="w220" disabled type="text" />
                                    <span class="txt">원</span>
                                </div>
                            </div>
                        </div>
                        <!-- 횟수 별 퍼센트 -->
                        <div v-show="useRadio.group == 'FP'" class="section">
                            <input class="w220" disabled type="text" />
                            <span class="txt">%</span>
                        </div>
                    </div>
                </div>
                <div v-show="useRadio.group == 'MO' || useRadio.group == 'FP'" class="line">
                    <span class="tit">
                        부가세 정책
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                    </span>
                    <div class="input-cnt">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s8-1" checked disabled name="radio-s8" type="radio" />
                                <label for="radio-s8-1">부가세를 제외하지 않습니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input id="radio-s8-2" disabled name="radio-s8" type="radio" />
                                <label for="radio-s8-2">1회당 단가에서 부가세 10%를 제외하고 정산합니다.</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">NO-SHOW(결석) 정책</span>
                    <div class="input-cnt flex-col">
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s9-1"
                                    v-model="usePayRadio.group"
                                    disabled
                                    name="radio-s9"
                                    type="radio"
                                    value="CME"
                                />
                                <label for="radio-s9-1">횟수차감과 동시에 동일한 금액으로 정산합니다.</label>
                            </div>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s9-2"
                                    v-model="usePayRadio.group"
                                    disabled
                                    name="radio-s9"
                                    type="radio"
                                    value="CMF"
                                />
                                <label for="radio-s9-2">횟수차감과 동시에</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">원으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s9-3"
                                    v-model="usePayRadio.group"
                                    disabled
                                    name="radio-s9"
                                    type="radio"
                                    value="CMP"
                                />
                                <label for="radio-s9-3">횟수차감과 동시에 기존급여의</label>
                            </div>
                            <input class="w60 center" disabled type="text" />
                            <span class="txt">% 으로 정산합니다.</span>
                        </div>
                        <div class="sub-line">
                            <div class="com-radio">
                                <input
                                    id="radio-s9-4"
                                    v-model="usePayRadio.group"
                                    disabled
                                    name="radio-s9"
                                    type="radio"
                                    value="CXX"
                                />
                                <label for="radio-s9-4">횟수차감만 하고 정산하지 않습니다. (정산금액 0원)</label>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- //그룹/쿠폰 급여 설정 -->

                <!-- 횟수 별 급여 포함 설정 -->
                <div class="gray-info-box">
                    <span class="title">
                        횟수 별 급여 포함 설정
                        <!--
                        제플린에 해당 디자인이 없는 관계로 주석처리함.
                        <div class="com-tooltip">
                            <button class="icon"></button>
                        </div>
                        -->
                    </span>
                    <p class="txt">
                        위에서 설정한 횟수 별 금액 or 퍼센트에 어떤 이용권의 횟수를 포함시키겠습니까?
                        <br />
                        횟수에 포함할 모든 이용권 종류를 선택 해 주세요. (중복 선택 가능)
                    </p>
                    <div class="line">
                        <div class="com-check">
                            <input
                                id="check-info-1"
                                :checked="countSetting[0] == 'Y'"
                                disabled
                                name="check-info"
                                type="checkbox"
                            />
                            <label for="check-info-1">개인</label>
                        </div>
                        <div class="com-check">
                            <input
                                id="check-info-2"
                                :checked="countSetting[1] == 'Y'"
                                disabled
                                name="check-info"
                                type="checkbox"
                            />
                            <label for="check-info-2">듀엣</label>
                        </div>
                        <div class="com-check">
                            <input
                                id="check-info-3"
                                :checked="countSetting[2] == 'Y'"
                                disabled
                                name="check-info"
                                type="checkbox"
                            />
                            <label for="check-info-3">오티</label>
                        </div>
                        <div class="com-check">
                            <input
                                id="check-info-4"
                                :checked="countSetting[3] == 'Y'"
                                disabled
                                name="check-info"
                                type="checkbox"
                            />
                            <label for="check-info-4">그룹</label>
                        </div>
                    </div>
                    <p class="txt">
                        ※ 위에서 선택한 이용권은 횟수만 합산될 뿐 설정한 이용권 개별 급여설정으로 적용됩니다.
                        <br />
                        ※ 1일 ~ 31일 동안 선택한 이용권 횟수의 총 합계로 횟수 별 급여 구간이 정해집니다.
                    </p>
                </div>
                <!-- //횟수 별 급여 포함 설정 -->
            </div>
        </div>

        <!-- 급여변동 내역 팝업 -->
        <div v-show="historyPop" class="layer-pop square">
            <div class="view-content w1425">
                <button class="close" @click="historyPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">급여변동내역</span>
                    <ul class="history-list">
                        <!-- <li>
                            <span class="day">2019-08-01 ~ 현재</span>
                            <div class="line">
                                <span class="txt">기본급</span>
                                <span class="detail">1,000,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">인센티브</span>
                                <span class="detail">총 매출의 6%</span>
                            </div>
                            <div class="line">
                                <span class="txt">개인</span>
                                <span class="detail">횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%</span>
                            </div>
                            <div class="line">
                                <span class="txt">듀엣</span>
                                <span class="detail">고정금액 - 30,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">OT</span>
                                <span class="detail">횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%</span>
                            </div>
                            <div class="line">
                                <span class="txt">그룹</span>
                                <span class="detail">인원별 2명 까지 20,000 원 / 4명 까지 25,000 원 / 4명 초과 30,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt red">횟수 별 포함 급여 *</span>
                                <span class="detail">[개인] [듀엣]</span>
                            </div>
                            <button class="com-btn red">삭제</button>
                        </li>
                        <li>
                            <span class="day">2019-08-01 ~ 현재</span>
                            <div class="line">
                                <span class="txt">기본급</span>
                                <span class="detail">1,000,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">인센티브</span>
                                <span class="detail">총 매출의 6%</span>
                            </div>
                            <div class="line">
                                <span class="txt">개인</span>
                                <span class="detail">횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%</span>
                            </div>
                            <div class="line">
                                <span class="txt">듀엣</span>
                                <span class="detail">고정금액 - 30,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">OT</span>
                                <span class="detail">횟수 별 퍼센트 - 80회 이하 30% / 90회 이하 40% / 90회 초과 50%</span>
                            </div>
                            <div class="line">
                                <span class="txt">그룹</span>
                                <span class="detail">인원별 2명 까지 20,000 원 / 4명 까지 25,000 원 / 4명 초과 30,000 원</span>
                            </div>
                            <div class="line">
                                <span class="txt red">횟수 별 포함 급여 *</span>
                                <span class="detail">[개인] [듀엣]</span>
                            </div>
                            <button class="com-btn red">삭제</button>
                        </li> -->
                        <li v-for="(item, index) in salaryList" :key="item.settingHistorySeq">
                            <span v-if="index == 0" class="day">
                                {{ item.applyStartDate | timestampFilter }} ~ 현재
                            </span>
                            <span v-else class="day">
                                {{ item.applyStartDate | timestampFilter }} ~ {{ item.applyEndDate | timestampFilter }}
                            </span>
                            <div class="line">
                                <span class="txt">기본급</span>
                                <span class="detail">{{ item.basePay | numberFormatFilter }} 원</span>
                            </div>
                            <div class="line">
                                <span class="txt">인센티브</span>
                                <span class="detail">
                                    신규 매출 의 {{ item.incentiveNewSale }}%, 재등록 매출 의
                                    {{ item.incentiveRenewSale }}%, 총 매출의 {{ item.incentiveTotalSale }}%
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">개인</span>
                                <span class="detail">
                                    {{ convertSalaryTypeFormat(item.lessonPersonType) }} - {{ item.lessonPersonPrice }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">듀엣</span>
                                <span class="detail">
                                    {{ convertSalaryTypeFormat(item.lessonDuetType) }} - {{ item.lessonDuetPrice }} 원
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">OT</span>
                                <span class="detail">
                                    {{ convertSalaryTypeFormat(item.lessonOtType) }} - {{ item.lessonOtPrice }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt">그룹</span>
                                <span class="detail">
                                    {{ convertSalaryGroupFormat(item.lessonGroupType) }} - {{ item.lessonGroupPrice }}
                                </span>
                            </div>
                            <div class="line">
                                <span class="txt red">횟수 별 포함 급여 *</span>
                                <span class="detail">{{ convertCount(item.countSetting) }}</span>
                            </div>
                            <!-- <button class="com-btn red">삭제</button> -->
                        </li>
                    </ul>
                    <b-pagination
                        align="center"
                        aria-controls="my-table"
                        first-class="first"
                        last-class="last"
                        next-class="next"
                        prev-class="prev"
                    ></b-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import { pagingInfo } from '@/assets/js/common';

export default {
    name: 'MypageSalary',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {},
    data() {
        return {
            historyPop: false, // 급여변동 내역보기 팝업
            useRadio: {
                private: '',
                duet: '',
                ot: '',
                group: '',
            },
            pay: {},
            incentiveVat: '', // 인센티브 부가세 정책
            usePayRadio: {
                private: '',
                duet: '',
                ot: '',
                group: '',
            },
            incentiveYn: false, // 인센티브 여부
            salaryList: [],
            centerId: '',
            centerStaffId: this.$store.state.auth.user.uid, // uid가 centerStaffId
            pagingInfo: { ...pagingInfo },
            countSetting: [],

            employeeInfo: {},
            staffTopInfo: {
                // 상단에 노출되는 직원 정보 UI
                name: '',
                phone: '',
                roleName: '',
                staffTeams: '',
            },
            basePay: '',
        };
    },
    mounted() {
        this.pagingInfo.page = 1;
        this.pagingInfo.limit = 10;
        this.centerId = this.cId; // 센터id
        this.onSearchList();
        this.onMemberList();
        this.onList(); // 급여변동내역 리스트 실행
    },
    methods: {
        // 담당 직원 API 호출
        async onMemberList() {
            try {
                this.isLoading = true;
                const { data } = await this.getMemberList();
                // this.setPageParams(data, 'center');
                this.employeeInfo = { ...data };

                const { employeeInfo, staffTopInfo } = this;
                this.defaultImageUrl = this.employeeInfo.imageUrl; // 사진

                staffTopInfo.name = employeeInfo.name;
                staffTopInfo.phone = employeeInfo.phone;

                if (employeeInfo.centerStaffRole) {
                    staffTopInfo.roleName = employeeInfo.centerStaffRole.roleName;
                } else {
                    staffTopInfo.roleName = '-';
                }

                if (employeeInfo.centerStaffTeams.length == 1) {
                    staffTopInfo.staffTeams = employeeInfo.centerStaffTeams[0].centerTeam.name;
                } else if (employeeInfo.centerStaffTeams.length == 0) {
                    staffTopInfo.staffTeams = '-';
                } else {
                    staffTopInfo.staffTeams = `${employeeInfo.centerStaffTeams[0].centerTeam.name} 외 ${
                        employeeInfo.centerStaffTeams.length - 1
                    }`;
                }

                this.isLoading = false;
                // console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 담당 직원 조회 API
        getMemberList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}`);
        },

        // 급여정보 호출
        async onSearchList() {
            try {
                this.isLoading = true;
                const { data } = await this.getCenterList();
                console.log('급여정보', data);
                // this.setPageParams(data, 'center');
                this.pay = data[0];
                this.basePay = this.numberConvert(data[0].basePay);
                this.useRadio.private = this.pay.lessonPersonType;
                this.useRadio.duet = this.pay.lessonDuetType;
                this.useRadio.ot = this.pay.lessonOtType;
                this.useRadio.group = this.pay.lessonGroupType;
                this.usePayRadio.private = this.pay.lessonPersonAtndType;
                this.usePayRadio.duet = this.pay.lessonDuetAtndType;
                this.usePayRadio.ot = this.pay.lessonOtAtndType;
                this.usePayRadio.group = this.pay.lessonGroupAtndType;
                this.vat = this.pay.incentiveVatYn;
                this.countSetting = this.pay.countSetting.split('');
                console.log(this.countSetting);
                // this.incentiveYn = this.pay.incentiveYn;
                this.isLoading = false;
                console.log('===> Success Loading centerList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },

        // 센터 목록 조회 API
        getCenterList() {
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/pay/setting`);
        },

        // 팝업 페이지 목록 리스트 가져오기
        async onList() {
            try {
                this.isLoading = true;
                const { data } = await this.getSalaryList();
                this.isLoading = false;
                this.salaryList = data.items;
                console.log('===> Success Loading SalaryList : ', data);
            } catch (error) {
                console.log(error);
                alert('오류가 발생했습니다.');
            }
        },
        // 팝업페이지 목록 리스트 조회 API
        getSalaryList() {
            const d = new Date();
            const ts = d.getTime();
            return api.get(`/admin/api/center/${this.centerId}/staff/${this.centerStaffId}/pay/setting/history`, {
                params: {
                    centerId: this.centerId,
                    centerStaffId: this.centerStaffId,
                    ...this.pagingInfo,
                },
            });
        },
        // 급여설정 코드
        convertSalaryTypeFormat(salaryType) {
            if (salaryType == 'FA') {
                return '고정급여';
            } else if (salaryType == 'FP') {
                return '고정퍼센트';
            } else if (salaryType == 'CA') {
                return '횟수별금액';
            } else if (salaryType == 'CP') {
                return '횟수별퍼센트';
            }
        },
        // 급여설정코드(그룹)
        convertSalaryGroupFormat(salaryType) {
            if (salaryType == 'TM') {
                return '타임별';
            } else if (salaryType == 'MO') {
                return '인당';
            } else if (salaryType == 'MT') {
                return '인원별';
            } else if (salaryType == 'FP') {
                return '고정퍼센트';
            }
        },
        // staff image 없을 경우 default image 표시
        imageUrlAlt(event) {
            event.target.src = '/img/temp/no_photo.jpg';
        },
        // 횟수별 급여 포함 설정
        convertCount(val) {
            const a = val.split('');
            console.log(a);
            let str = '';
            if (a[0] == 'Y') {
                str += '[개인] ';
            }
            if (a[1] == 'Y') {
                str += '[듀엣] ';
            }
            if (a[2] == 'Y') {
                str += '[OT] ';
            }
            if (a[3] == 'Y') {
                str += '[그룹] ';
            }
            return str;
        },
        numberConvert(number) {
            if (number === null || number === '' || number === undefined) {
                return number;
            }
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
        // 급여변동내역 실행
        onPriceHistory() {
            this.historyPop = true;
        },
    },
};
</script>
<style lang="scss"></style>
